import className from '../../common/className.js'
import ExportCSVButton from './ExportCSVButton.js'
import ValueByStateGraph from './ValueByStateGraph.js'

/**
 * Revenue by State Map
 *
 * @param {Object} props
 * @param {Boolean} props.isLoading
 * @param {Object} props.revenueByState
 * @param {Function} props.onExport
 * @returns {React.ReactNode}
 */
export default function RevenueByStateMap({
  isLoading,
  revenueByState,
  onExport,
}) {
  return (
    <div className="row">
      <div className="medium-12 columns">
        <div
          className={className`panel panel--analytics clearfix ${{
            loading: isLoading,
          }}`}
        >
          <div className="panel__header panel__header--analytics flex--justify">
            <h3 className="subheader subheader--analytics">Revenue by State</h3>
            {revenueByState && <ExportCSVButton onExport={onExport} />}
          </div>
          <ValueByStateGraph data={revenueByState} />
        </div>
      </div>
    </div>
  )
}
